export default "__VITE_PUBLIC_ASSET__fc7cc626__"